import React, { useState, useEffect } from "react";
import Select from "react-select";
 
const SelectServiceCity = ({
  selectedStates,
  name,
  label,
  onChange,
  selectedCities = [],
  setSelectedCities,
  franchiseCities = [],
}) => {
  const [cities, setCities] = useState([]);
 
  useEffect(() => {
    // 1. Safe Guard Arrays
    if (!Array.isArray(franchiseCities) || !Array.isArray(selectedStates)) {
      setCities([]);
      return;
    }
 
    if (selectedStates.length === 0) {
      setCities([]);
      // Sync clean state upward if there were cities selected previously
      if (Array.isArray(selectedCities) && selectedCities.length > 0) {
        setSelectedCities([]);
        onChange([]);
      }
      return;
    }
 
    // 2. Extract Selected State IDs safely
    const stateIds = selectedStates
      .map((state) =>
        typeof state === "object" && state !== null
          ? Number(state.value)
          : Number(state)
      )
      .filter((id) => !isNaN(id));
 
    // 3. Filter down to the available cities
    const filteredCities = franchiseCities.filter((city) =>
      stateIds.includes(Number(city.state_id))
    );
 
    // 4. Map to React-Select formatted options
    const formattedOptions = filteredCities.map((city) => ({
      value: city.id,
      label: city.name,
    }));
 
    setCities(formattedOptions);
 
    // 5. Clean up stale/invalid selections simultaneously (Prevents Infinite Loop)
    if (Array.isArray(selectedCities) && selectedCities.length > 0) {
      const validCityIds = selectedCities.filter((id) =>
        formattedOptions.some((option) => Number(option.value) === Number(id))
      );
 
      // Only notify parent components if an actual filtering mismatch occurred
      if (validCityIds.length !== selectedCities.length) {
        setSelectedCities(validCityIds);
        onChange(validCityIds);
      }
    }
   
    // Explicitly listing accurate dependencies ensures synchronization runs smoothly
  }, [selectedStates, franchiseCities, onChange, setSelectedCities]);
 
  const handleCitySelect = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
 
    setSelectedCities(values);
    onChange(values);
  };
 
  const getSelectedOptions = () => {
    if (!Array.isArray(selectedCities) || selectedCities.length === 0) {
      return [];
    }
 
    return cities.filter((city) =>
      selectedCities.some((id) => Number(id) === Number(city.value))
    );
  };
 
  const customStyles = {
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: 0,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };
 
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
          {label}
        </label>
      )}
 
      <Select
        isMulti
        name={name}
        options={cities}
        value={getSelectedOptions()}
        onChange={handleCitySelect}
        placeholder="--Choose--"
        classNamePrefix="react-select"
        className="text-sm focus:outline-none block w-full bg-white dark:bg-gray-800 text-black dark:text-gray-200"
        styles={customStyles}
      />
    </div>
  );
};
 
export default SelectServiceCity;
 